exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.top[data-v-ecc3bd36]{position:fixed;width:2.85rem;height:2.85rem;right:1.25rem;bottom:2.5rem;z-index:5\n}\n.top img[data-v-ecc3bd36]{display:block;width:100%\n}\n", "", {"version":3,"sources":["/build/src/components/base/topBtn.vue"],"names":[],"mappings":";AAAA,sBAAK,eAAe,cAAc,eAAe,cAAc,cAAc,SAAS;CAAC;AAAA,0BAAS,cAAc,UAAU;CAAC","file":"topBtn.vue","sourcesContent":[".top{position:fixed;width:2.85rem;height:2.85rem;right:1.25rem;bottom:2.5rem;z-index:5}.top img{display:block;width:100%}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ecc3bd36","scoped":true,"hasInlineConfig":false}!./build/loader/img-loader.js?{"replace":"~_style/common/img"}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/base/topBtn.vue
// module id = eGCz
// module chunks = 37